import { getLocationChangeText } from "../map/helpers";
import { getPropsForClickTracking } from "../../utils/tracking";
$ const { zipcode, distance } = input ?? {};
$ const locationChangeText = getLocationChangeText(zipcode, distance);

<div class="map-location-change" data-testid="map-location-change">
  <ebay-filter-chip
    data-testid="map-location-change-btn"
    on-click("onLocationBtnClick")
    selected
    ...getPropsForClickTracking(input.locationChangeClickAction?.trackingList)
  >
    <@icon>
      <ebay-location-16-icon/>
    </@icon>
    <fe-textual-display model=locationChangeText/>
  </ebay-filter-chip>
</div>
